import imgUrl from '../assets/bg_login_blue.jpg'
// document.getElementById('hero-img').style.background = `url("${imgUrl}")`
function OpenWindow(_this, paraList, AccessType) {
    _this.$store.commit('setRouteParam', paraList);
    _this.$store.commit('setAccessType', AccessType);
    window.open('MD/CameraFunc.html', 'Shinsoft', 'height=768,width=648,menubar=no,resizable=no,status=no,toolbar=no,location=no,scrollbars=no');
}
function SetClearFunction(_this) {
    if (!window.MDClearFunction){
        window.MDClearFunction = function () {
            _this.$store.commit('setRouteParam', []);
            _this.$store.commit('setAccessType', '');
        };
    }
    if (!window.MDBackgroundImg) {
        window.MDBackgroundImg = function () {
            return `url("${imgUrl}")`;
        };
    }
}
function RemoveClearFunction() {
    window.MDClearFunction = undefined;
    window.MDBackgroundImg = undefined;
}
export default {
    OpenWindow,
    SetClearFunction,
    RemoveClearFunction
}
